import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread({
        width: "95",
        height: "91",
        viewBox: "0 0 95 91",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props));
};
export default Icon;
